






























import Vue from 'vue'
import AdminUserDropdown from '@/modules/common/layout/components/admin/AdminUserDropdown.vue'
import NotificationsBell from '@/modules/notification/components/shared/NotificationsBell.vue'
import { Component } from '@niknevis/vue-modules'
import Today from '@/modules/common/layout/components/shared/Today.vue'
import { Prop, Watch } from 'vue-property-decorator'
import ToolbarDialogButton from '@/modules/shared/components/shared/utils/ToolbarDialogButton.vue'
import WidgetTomanConverter from '@/modules/common/widgets/components/tools/WidgetTomanConverter.vue'

@Component({
  components: {
    WidgetTomanConverter,
    ToolbarDialogButton,
    AdminUserDropdown,
    NotificationsBell,
    Today
  }
})
export default class AdminTopHeader extends Vue {
  @Prop() unreadNotifications!: number
  @Prop() showSwitchUser!: boolean
  @Prop() dark!: boolean
  @Prop() orig_user!: string | null
  private shadow = false
  private showTools: boolean = false

  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  }

  @Watch('$page.url', { immediate: true, deep: true })
  onRouteChange(val) {
    this.showTools = val.includes('financial')
  }

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    this.shadow = window.scrollY > 0
  }

  get showSwitchUserSync() {
    return this.showSwitchUser && !!this.orig_user
  }

  toggleDrawer() {
    this.$emit('toggleDrawer')
  }
}
